import { render, staticRenderFns } from "./HistoryLogs.vue?vue&type=template&id=3c705975&scoped=true"
import script from "./HistoryLogs.vue?vue&type=script&lang=ts"
export * from "./HistoryLogs.vue?vue&type=script&lang=ts"
import style0 from "./HistoryLogs.vue?vue&type=style&index=0&id=3c705975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c705975",
  null
  
)

export default component.exports